export default __webpack_public_path__ + "static/media/Gotham-MediumIta.df963d56.otf";